import { booleanPointInPolygon } from '@turf/boolean-point-in-polygon'
import { polygon, point } from '@turf/helpers'

export interface bboxProductDetailsInterface {
  bounds: any[]
  products: Set<string>
  region: string
}

export enum BoundingRegionsEnum {
  DEFAULT = 'default',
  USA_TX_ELIZABETHTOWN = 'usa-tx-elizabethtown',
  USA = 'US',
  ALASKA = 'Alaska',
  CANADA = 'Canada',
  WESTERN_EUROPE = 'W-Europe',
  CENTRAL_EUROPE = 'C-Europe',
  MIDDLE_EAST = 'M-East',
  SAO_PAULO = 'Sao Paulo',
}

const boundingBoxes: bboxProductDetailsInterface[] = [
  {
    bounds: [
      [-97.825012, 32.527131],
      [-97.825012, 33.477272],
      [-96.586304, 33.477272],
      [-96.586304, 32.527131],
      [-97.825012, 32.527131],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'decision-routecast',
      'swaps-3d-winds',
      'radar-menu',
      'observations-mrms-radar',
      'observations-myradar',
      'observations-lightning',
      'observations-menu',
      'surface-observations-menu',
      'elevated-surface-observations-menu',
      'camera-network',
      'vertical-profile',
      'area-weather-menu',
      'weather-menu',
      'forecast-weather-menu',
      'aviation-menu',
      'aviation-hazards',
      'aviation-pirep',
      'aviation-airmet',
      'aviation-sigmet',
      'aviation-metar',
      'aviation-taf',
      'aviation-wafs-icing',
      'aviation-wafs-turbulence',
      'forecaster-menu',
      'dark-mode-menu',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'casa-denton-radar',
      'casa-denton-radar2',
      'observations-casa-radar',
      'ip-camera-historical-data',
    ]),
    region: BoundingRegionsEnum.USA_TX_ELIZABETHTOWN,
  },

  {
    bounds: [
      [-134.5, 20],
      [-134.5, 56],
      [-60, 56],
      [-60, 20],
      [-134.5, 20],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'decision-routecast',
      'radar-menu',
      'observations-mrms-radar',
      'observations-myradar',
      'observations-lightning',
      'observations-menu',
      'surface-observations-menu',
      'elevated-surface-observations-menu',
      'camera-network',
      'vertical-profile',
      'area-weather-menu',
      'weather-menu',
      'forecast-weather-menu',
      'aviation-menu',
      'aviation-hazards',
      'aviation-pirep',
      'aviation-airmet',
      'aviation-sigmet',
      'aviation-metar',
      'aviation-taf',
      'aviation-wafs-icing',
      'aviation-wafs-turbulence',
      'forecaster-menu',
      'dark-mode-menu',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
    ]),
    region: BoundingRegionsEnum.USA,
  },
  {
    bounds: [
      [-172.11, 71.83],
      [-172.11, 51.7],
      [-140.78, 51.7],
      [-140.78, 71.83],
      [-172.11, 71.83],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'decision-routecast',
      'radar-menu',
      'observations-mrms-radar',
      'observations-myradar',
      'observations-lightning',
      'observations-menu',
      'surface-observations-menu',
      'camera-network',
      'vertical-profile',
      'area-weather-menu',
      'weather-menu',
      'forecast-weather-menu',
      'aviation-menu',
      'aviation-hazards',
      'aviation-pirep',
      'aviation-airmet',
      'aviation-sigmet',
      'aviation-metar',
      'aviation-taf',
      'aviation-wafs-icing',
      'aviation-wafs-turbulence',
      'forecaster-menu',
      'dark-mode-menu',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'casa-denton-radar',
      'casa-denton-radar2',
    ]),
    region: BoundingRegionsEnum.ALASKA,
  },
  {
    bounds: [
      [-138, 55],
      [-138, 70],
      [-55, 70],
      [-55, 55],
      [-138, 55],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: BoundingRegionsEnum.CANADA,
  },
  {
    bounds: [
      [-10.9, 36.39],
      [-10.9, 57.79],
      [10, 57.79],
      [10, 36.39],
      [-10.9, 36.39],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'decision-routecast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'camera-network',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: BoundingRegionsEnum.WESTERN_EUROPE,
  },
  {
    bounds: [
      [10, 43.5],
      [10, 63.6],
      [30.79, 63.6],
      [30.79, 43.5],
      [10, 43.5],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'decision-routecast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'camera-network',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: BoundingRegionsEnum.CENTRAL_EUROPE,
  },
  {
    bounds: [
      [-10.9, 36.39],
      [-10.9, 57.79],
      [10, 57.79],
      [10, 36.39],
      [-10.9, 36.39],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'decision-routecast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'camera-network',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: BoundingRegionsEnum.WESTERN_EUROPE,
  },
  {
    bounds: [
      [10, 43.5],
      [10, 63.6],
      [30.79, 63.6],
      [30.79, 43.5],
      [10, 43.5],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'decision-routecast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'camera-network',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: BoundingRegionsEnum.CENTRAL_EUROPE,
  },
  {
    bounds: [
      [34, 20],
      [34, 33.89],
      [57.1, 33.89],
      [57.1, 20],
      [34, 20],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: BoundingRegionsEnum.MIDDLE_EAST,
  },
  {
    bounds: [
      [-47.4, -24],
      [-47.4, -22.8],
      [-45.51, -22.8],
      [-45.51, -24],
      [-47.4, -24],
    ],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-ceiling',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: BoundingRegionsEnum.SAO_PAULO,
  },
]

const tilesIdSet = new Set([
  'aviation-ceiling',
  'aviation-visibility',
  'aviation-temperature',
  'aviation-surfacewinds',
  'aviation-winds-80m',
  'aviation-wind-gust',
])
const tilesIdRegionMap = {
  'usa-tx-elizabethtown': {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-wind-gust',
  },
  US: {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-wind-gust',
  },
  Alaska: {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-wind-gust',
  },
  Canada: {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-wind-gust': 'aviation-windgust',
  },
  'W-Europe': {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-wind-gust',
  },
  'C-Europe': {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-wind-gust',
  },
  'M-East': {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-wind-gust',
  },
  'Sao Paulo': {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-windgust',
  },
  Default: {
    'aviation-ceiling': 'aviation-ceiling',
    'aviation-visibility': 'aviation-visibility',
    'aviation-temperature': 'aviation-temperature',
    'aviation-surface-winds': 'aviation-surface-winds',
    'aviation-winds-80m': 'aviation-winds-80m',
    'aviation-wind-gust': 'aviation-wind-gust',
  },
}

interface Location {
  longitude: number
  latitude: number
  [key: string]: any
}

function getRegionBasedServices(currentLocation: Location): object {
  var region = {
    bounds: [],
    products: new Set([
      'location-menu',
      'add-location',
      // Alerting is offered at every location. It was previously listed only for
      // the US / Alaska / Elizabethtown boxes and omitted from the 'Default'
      // fallback, while the ProfileMenu entry ignored regions entirely and showed
      // it worldwide - so the sets, not the menu, were the stale side.
      'alerts-menu',
      'alerts-create',
      'decision-products-menu',
      'decision-missioncast',
      'radar-menu',
      'observations-menu',
      'surface-observations-menu',
      'aviation-menu',
      'aviation-pirep',
      'aviation-metar',
      'aviation-taf',
      'forecast-aviation-ceiling',
      'forecast-aviation-visibility',
      'forecast-aviation-temperature',
      'forecast-aviation-surface-winds',
      'forecast-aviation-winds-80m',
      'forecast-aviation-wind-gust',
      'aviation-visibility',
      'aviation-temperature',
      'aviation-surface-winds',
      'aviation-winds-80m',
      'aviation-wind-gust',
      'weather-menu',
      'area-weather-menu',
      'dark-mode-menu',
      'observations-xweather-radar',
    ]),
    region: 'Default',
  }
  var pt = point([-76.14, 43.04])
  if (currentLocation.longitude && currentLocation.latitude) {
    pt = point([currentLocation.longitude, currentLocation.latitude])
  }
  for (let boxes of boundingBoxes) {
    let currrPolygon = polygon([boxes.bounds])
    if (booleanPointInPolygon(pt, currrPolygon)) return boxes
  }
  return region
}

export { getRegionBasedServices, tilesIdSet, tilesIdRegionMap }
